var map = {
	"./arrow_left.svg": 3556,
	"./arrow_right.svg": 219,
	"./arrow_right_lucide.svg": 4218,
	"./arrows_up_down.svg": 9272,
	"./calendar.svg": 3060,
	"./caret_down.svg": 9221,
	"./caret_left.svg": 5166,
	"./caret_right.svg": 5677,
	"./check.svg": 1691,
	"./chevron_down.svg": 7009,
	"./display_logo.svg": 2269,
	"./edit_dots.svg": 7304,
	"./error.svg": 8029,
	"./eye.svg": 4704,
	"./eye_off.svg": 686,
	"./filetype_folder.svg": 3766,
	"./filetype_generated.svg": 2097,
	"./filetype_group.svg": 7583,
	"./filetype_set.svg": 6606,
	"./filetype_single_image.svg": 2004,
	"./filetype_single_pdf.svg": 8005,
	"./filetype_single_video.svg": 4126,
	"./home.svg": 532,
	"./hourglass.svg": 9029,
	"./info.svg": 7865,
	"./list.svg": 3909,
	"./log_out.svg": 8404,
	"./logout.svg": 8619,
	"./menu.svg": 7184,
	"./nav_dashboard.svg": 5473,
	"./nav_displays.svg": 4358,
	"./nav_generator.svg": 1446,
	"./nav_media.svg": 9897,
	"./nav_playlists.svg": 7760,
	"./nav_redaktion.svg": 3898,
	"./nav_settings.svg": 736,
	"./nav_users.svg": 6425,
	"./sorting.svg": 1803,
	"./success.svg": 2110,
	"./tiles.svg": 5592,
	"./times.svg": 5477,
	"./trash.svg": 297,
	"./trash_outline.svg": 4438,
	"./upload.svg": 2030,
	"./warning.svg": 9251,
	"./x.svg": 1967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7852;